var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg from 'ha/ui/next/SvgIcon';

const SvgFaq = props => /*#__PURE__*/React.createElement(Svg, _extends({
  "data-name": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16.93 16.54a.58.58 0 00-.35.53.58.58 0 11-1.16 0 1.75 1.75 0 011-1.6 1.17 1.17 0 00.65-1.39 1.16 1.16 0 00-1.28-.84 1.17 1.17 0 00-1 1.16.58.58 0 11-1.16 0 2.33 2.33 0 113.26 2.14zM16 20.08a.88.88 0 11.88-.87.88.88 0 01-.88.87zM16 9a7 7 0 107 7 7 7 0 00-7-7z",
  fill: "#00c5ba"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M16 30c1 0 3-2.81 3-2.81 2.14-.09 6-.24 8.18-.44a3.09 3.09 0 002.73-2.63 55.37 55.37 0 00.6-8.12 55.37 55.37 0 00-.6-8.12 3.09 3.09 0 00-2.73-2.63 116.206 116.206 0 00-22.36 0 3.09 3.09 0 00-2.73 2.63 55.25 55.25 0 000 16.24 3.09 3.09 0 002.73 2.63c.77.07 5.77.21 8.18.33 0 0 2 2.92 3 2.92z",
  fill: "none",
  stroke: "#2d4658",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
})));

export default SvgFaq;